import React from 'react';

import Image from 'next/image';

import {
  SearchHeaderContainer,
  SearchHeaderLink,
  SearchHeaderLinkText,
  SearchHeaderText,
  SearchHeaderTitle,
  TitleIconContainer,
} from './SearchSectionHeader.style';

interface SearchSectionHeaderProps {
  title?: string;
  rightHeaderHandler?: () => void;
  rightHeaderText?: string;
  titleIcon?: string;
}

const SearchSectionHeader: React.FC<SearchSectionHeaderProps> = ({
  title = '',
  titleIcon = '',
  rightHeaderHandler,
  rightHeaderText,
}) => {
  return (
    <SearchHeaderContainer>
      <SearchHeaderTitle>
        {titleIcon && (
          <TitleIconContainer>
            <Image
              width={20}
              height={20}
              src={titleIcon}
              alt="icon"
              loading="eager"
              fetchPriority="high"
              priority
            />
          </TitleIconContainer>
        )}
        {/* Left Title */}
        <SearchHeaderText variant="h3"> {title}</SearchHeaderText>
      </SearchHeaderTitle>

      {/* Right link */}
      {rightHeaderText && (
        <SearchHeaderLink onClick={rightHeaderHandler}>
          <SearchHeaderLinkText>{rightHeaderText}</SearchHeaderLinkText>
        </SearchHeaderLink>
      )}
    </SearchHeaderContainer>
  );
};

export default SearchSectionHeader;
